export default "__VITE_ASSET__CZxD0V5y__"